var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1943 100H9.25586V8.71875H74.6088V97.5857C74.6088 98.9191 73.5279 100 72.1943 100Z",
    fill: "#82AEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0092 91.2816H9.25586V8.71875H80.009C81.3424 8.71875 82.4234 9.7998 82.4234 11.1332V88.8674C82.4236 90.2008 81.3426 91.2816 80.0092 91.2816Z",
    fill: "#D3E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25547 0C4.44043 0 0.537109 3.90332 0.537109 8.71855V91.2816C0.537109 86.4666 4.44043 82.5631 9.25566 82.5631C14.0709 82.5631 17.9742 86.4664 17.9742 91.2816V8.71855C17.974 3.90332 14.0707 0 9.25547 0V0Z",
    fill: "#B2CAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6941 21.4145H35.6008C34.7672 21.4145 34.0918 20.7389 34.0918 19.9055C34.0918 19.0719 34.7674 18.3965 35.6008 18.3965H65.6941C66.5277 18.3965 67.2031 19.0721 67.2031 19.9055C67.2031 20.7389 66.5277 21.4145 65.6941 21.4145Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2783 33.4242H29.0187C28.1852 33.4242 27.5098 32.7486 27.5098 31.9152C27.5098 31.0816 28.1854 30.4062 29.0187 30.4062H72.2783C73.1119 30.4062 73.7873 31.0818 73.7873 31.9152C73.7875 32.7486 73.1119 33.4242 72.2783 33.4242Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2783 44.6156H29.0187C28.1852 44.6156 27.5098 43.94 27.5098 43.1066C27.5098 42.2732 28.1854 41.5977 29.0187 41.5977H72.2783C73.1119 41.5977 73.7873 42.2732 73.7873 43.1066C73.7873 43.94 73.1119 44.6156 72.2783 44.6156Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2783 56.4662H29.0187C28.1852 56.4662 27.5098 55.7906 27.5098 54.9572C27.5098 54.1238 28.1854 53.4482 29.0187 53.4482H72.2783C73.1119 53.4482 73.7873 54.1238 73.7873 54.9572C73.7873 55.7906 73.1119 56.4662 72.2783 56.4662Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2783 68.3168H29.0187C28.1852 68.3168 27.5098 67.6412 27.5098 66.8078C27.5098 65.9744 28.1854 65.2988 29.0187 65.2988H72.2783C73.1119 65.2988 73.7873 65.9744 73.7873 66.8078C73.7873 67.6412 73.1119 68.3168 72.2783 68.3168Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2783 80.1674H29.0187C28.1852 80.1674 27.5098 79.4918 27.5098 78.6584C27.5098 77.825 28.1854 77.1494 29.0187 77.1494H72.2783C73.1119 77.1494 73.7873 77.825 73.7873 78.6584C73.7873 79.4918 73.1119 80.1674 72.2783 80.1674Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4023 49.2959H99.4627V84.8023H89.4023V49.2959Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4627 84.8027H89.4023L93.7998 92.8717C94.0728 93.3729 94.7924 93.3729 95.0654 92.8717L99.4627 84.8027Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1674 19.2611H90.6953V14.3346C90.6953 13.0096 91.7693 11.9355 93.0943 11.9355H95.7684C97.0934 11.9355 98.1674 13.0096 98.1674 14.3346V19.2611Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5836 19.2617H90.2814C89.7959 19.2617 89.4023 19.6553 89.4023 20.1408V24.8291H99.4627V20.1408C99.4627 19.6553 99.0691 19.2617 98.5836 19.2617Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4023 24.8291H99.4627V49.2965H89.4023V24.8291Z",
    fill: "#0473CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0084 8.71875H72.0234C73.3568 8.71875 74.4379 9.7998 74.4379 11.1332V88.8672C74.4379 90.2006 73.3568 91.2816 72.0234 91.2816H80.0084C81.3418 91.2816 82.4228 90.2006 82.4228 88.8672V11.1332C82.4228 9.79961 81.3418 8.71875 80.0084 8.71875Z",
    fill: "#C0D6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25566 99.9996C14.0708 99.9996 17.9742 96.0962 17.9742 91.2811C17.9742 86.4659 14.0708 82.5625 9.25566 82.5625C4.44054 82.5625 0.537109 86.4659 0.537109 91.2811C0.537109 96.0962 4.44054 99.9996 9.25566 99.9996Z",
    fill: "#82AEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3281 49.2959H99.4613V84.8023H94.3281V49.2959Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3289 84.8027L91.8652 89.3234L93.799 92.8717C94.0721 93.3729 94.7916 93.3729 95.0646 92.8717L99.4621 84.8027H94.3289Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5824 19.2617H93.4492C93.9348 19.2617 94.3283 19.6553 94.3283 20.1408V24.8291H99.4615V20.1408C99.4615 19.6553 99.068 19.2617 98.5824 19.2617Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3281 24.8291H99.4613V49.2965H94.3281V24.8291Z",
    fill: "#0067C5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.05e9774c809e5541ed203b4c0fb57622.svg";
export { ForwardRef as ReactComponent };